import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.resolvedLanguage?.startsWith('en');

  return (
    <footer className="bg-[#0A1628] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/adb35acbf43dddb6c47392f03bc1d026/0f2f158cfd9960d53447a4fff3ef67e1.png"
                  alt="Aero Destiny Travel"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <span className="text-2xl font-bold">Aero Destiny Travel</span>
            </div>
            <p className="text-white/80 leading-relaxed mb-6 max-w-md">
              {t('homeSections.footer.brandDescription')}
            </p>
            <div className="flex items-center gap-4 mb-8">
              <a href="https://www.instagram.com/aerodestiny" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9A84C] transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://www.facebook.com/AeroDestinyTravel" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9A84C] transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://wa.me/5562995436807" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9A84C] transition-all duration-300 cursor-pointer">
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a href="https://agencia.iddas.com.br/so/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9A84C] transition-all duration-300 cursor-pointer">
                <i className="ri-global-line text-xl"></i>
              </a>
            </div>

            {/* Formas de Pagamento */}
            <div>
              <h4 className="text-sm font-bold text-white/80 uppercase tracking-widest mb-3">
                {t('homeSections.footer.paymentTitle')}
              </h4>
              <div className="flex items-center gap-3 flex-wrap">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 text-white/90 text-xs font-semibold">
                  <i className="ri-bank-card-line text-[#C9A84C]"></i>
                  Amex
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 text-white/90 text-xs font-semibold">
                  <i className="ri-qr-code-line text-[#C9A84C]"></i>
                  Pix
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 text-white/90 text-xs font-semibold">
                  <i className="ri-money-dollar-circle-line text-[#C9A84C]"></i>
                  {isEnglish ? 'Cash' : 'Dinheiro'}
                </span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-[#C9A84C]">{t('homeSections.footer.navigationTitle')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#hero" className="text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">{t('header.home')}</a>
              </li>
              <li>
                <a href="#como-funciona" className="text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">{t('header.howItWorks')}</a>
              </li>
              <li>
                <a href="#experiencias" className="text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">{t('header.experiences')}</a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">{t('header.contact')}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-[#C9A84C]">{t('homeSections.footer.contactTitle')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:contato@aerodestinytravel.com" className="flex items-start gap-2 text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">
                  <i className="ri-mail-line text-[#C9A84C] mt-1"></i>
                  <span>contato@aerodestinytravel.com</span>
                </a>
              </li>
              <li>
                <a href="tel:+5562995436807" className="flex items-start gap-2 text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">
                  <i className="ri-phone-line text-[#C9A84C] mt-1"></i>
                  <span>+55 62 99543-6807</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/80">
                <i className="ri-map-pin-line text-[#C9A84C] mt-1"></i>
                <span>{t('homeSections.footer.location')}</span>
              </li>
            </ul>

            <h4 className="text-lg font-bold mt-6 mb-3 text-[#C9A84C]">{t('homeSections.footer.socialTitle')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://www.instagram.com/aerodestiny" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-[#C9A84C]"></i>
                  <span>@aerodestiny</span>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/AeroDestinyTravel" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/80 hover:text-[#C9A84C] transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-[#C9A84C]"></i>
                  <span>Aero Destiny Travel</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <p className="text-white/80 text-sm text-center">
            {t('homeSections.footer.rights')}
          </p>
          <a href="/privacy.html" className="text-sm text-white/80 underline-offset-4 hover:text-[#C9A84C] hover:underline">{isEnglish ? 'Privacy Policy' : 'Política de Privacidade'}</a>
        </div>
      </div>
    </footer>
  );
}
